import { Grid } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { FooterLink } from '../../styles';
import { COMPANY_INFO, FOOTER_MENUS } from '../../variables';
import { FooterTitles } from './Footer';

const AboutUs = () => {
  return (
    <Grid
      item
      xs={3}
    >
      <FooterTitles variant='h4'>{COMPANY_INFO.name}</FooterTitles>

      {FOOTER_MENUS.menu1.map((menuItem, index) => (
        <FooterLink
          key={`footer-menu-${menuItem.title}-${index}`}
          component={menuItem.internalLink ? Link : 'a'}
          to={menuItem.internalLink ? menuItem.url : null}
          href={!menuItem.internalLink ? menuItem.url : null}
          target={!menuItem.internalLink ? menuItem.target : null}
          title={menuItem.title}
          variant='link'
          marginBottom={0.75}
        >
          {menuItem.title}
        </FooterLink>
      ))}
    </Grid>
  );
};

export default AboutUs;
